import Router from 'vue-router'
import { Card } from './routes'

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '*', redirect: { name: 'card' } },
    Card
  ]
})
